/**
 * SVG Stromlaufplan — Torampel Steuerung
 * DIN/IEC Darstellung, sauber wie Schneider Electric QuickFlex
 */
export function SchaltplanSVG({ ampelRot, ampelGruen, hauptschalter, className = "" }) {
  // Active path highlighting
  const activeStroke = "#3b82f6";
  const inactiveStroke = "#1e293b";
  const labelColor = "#94a3b8";
  const dimColor = "#334155";

  const lActive = hauptschalter ? activeStroke : inactiveStroke;
  const rotPath = ampelRot ? "#ef4444" : inactiveStroke;
  const gruenPath = ampelGruen ? "#22c55e" : inactiveStroke;

  return (
    <svg
      viewBox="0 0 460 580"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={{ background: "#0a0c10", borderRadius: 8 }}
    >
      <defs>
        <style>{`
          text { font-family: 'SF Mono', 'Fira Code', monospace; }
          .label { fill: ${labelColor}; font-size: 9px; font-weight: 600; }
          .label-sm { fill: ${dimColor}; font-size: 7px; }
          .label-id { fill: #60a5fa; font-size: 9px; font-weight: 700; }
          .label-warn { fill: #f59e0b; font-size: 7px; font-weight: 700; }
          .bus { stroke-width: 2.5; }
          .wire { stroke-width: 1.5; fill: none; stroke-linecap: round; stroke-linejoin: round; }
          .wire-thin { stroke-width: 1; fill: none; }
          .symbol { stroke-width: 1.5; fill: none; }
          .dot { fill: currentColor; }
        `}</style>
      </defs>

      {/* ═══ TITLE ═══ */}
      <text x="230" y="22" textAnchor="middle" fill="#e2e8f0" style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1 }}>STROMLAUFPLAN — TORAMPEL STEUERUNG</text>

      {/* ═══ BUS BARS L / N ═══ */}
      {/* L bus */}
      <line x1="40" y1="50" x2="420" y2="50" className="bus" stroke={lActive} />
      <text x="25" y="53" className="label" fill="#ef4444" style={{ fontWeight: 800 }}>L</text>
      <circle cx="40" cy="50" r="2.5" fill={lActive} />

      {/* N bus */}
      <line x1="40" y1="530" x2="420" y2="530" className="bus" stroke="#3b82f6" />
      <text x="25" y="533" className="label" fill="#3b82f6" style={{ fontWeight: 800 }}>N</text>
      <circle cx="40" cy="530" r="2.5" fill="#3b82f6" />

      {/* PE bus */}
      <line x1="40" y1="560" x2="420" y2="560" className="bus" stroke="#22c55e" strokeDasharray="6 4" />
      <text x="22" y="563" className="label" fill="#22c55e" style={{ fontWeight: 800 }}>PE</text>

      {/* ═══ COLUMN 1: Q1 Hauptschalter (x=80) ═══ */}
      <line x1="80" y1="50" x2="80" y2="90" className="wire" stroke={lActive} />
      <circle cx="80" cy="50" r="2.5" fill={lActive} />
      {/* Switch symbol */}
      <line x1="80" y1="90" x2="80" y2="100" className="wire" stroke={lActive} />
      <circle cx="80" cy="100" r="2" fill={lActive} />
      {hauptschalter ? (
        <line x1="80" y1="100" x2="80" y2="130" className="wire" stroke={lActive} />
      ) : (
        <line x1="80" y1="100" x2="92" y2="128" className="wire" stroke={inactiveStroke} />
      )}
      <circle cx="80" cy="130" r="2" fill={lActive} />
      <line x1="80" y1="130" x2="80" y2="145" className="wire" stroke={lActive} />
      {/* Label */}
      <text x="56" y="118" className="label-id">Q1</text>
      <text x="92" y="108" className="label-sm">Haupt-</text>
      <text x="92" y="116" className="label-sm">schalter</text>

      {/* ═══ COLUMN 2: F1 LS B16A (x=80, below Q1) ═══ */}
      <line x1="80" y1="145" x2="80" y2="160" className="wire" stroke={lActive} />
      {/* LS symbol - rectangle */}
      <rect x="72" y="160" width="16" height="24" rx="2" fill="none" stroke={lActive} strokeWidth="1.5" />
      <line x1="76" y1="172" x2="84" y2="172" stroke={lActive} strokeWidth="1" />
      <line x1="80" y1="184" x2="80" y2="200" className="wire" stroke={lActive} />
      {/* Label */}
      <text x="56" y="175" className="label-id">F1</text>
      <text x="92" y="170" className="label-sm">LS</text>
      <text x="92" y="178" className="label-sm">B16A</text>

      {/* ═══ Wire from F1 to S1 ═══ */}
      <line x1="80" y1="200" x2="80" y2="240" className="wire" stroke={lActive} />

      {/* ═══ COLUMN 3: S1 Wahlschalter (x=80, 3-Pos) ═══ */}
      <circle cx="80" cy="240" r="2.5" fill={lActive} />
      {/* Switch body - dashed box */}
      <rect x="60" y="232" width="120" height="56" rx="4" fill="none" stroke={dimColor} strokeWidth="0.8" strokeDasharray="3 2" />
      <text x="63" y="244" className="label-id">S1</text>
      <text x="95" y="244" className="label-sm">M22-WRK3 (3-Pos)</text>

      {/* POS labels */}
      <text x="73" y="280" className="label-sm" style={{ fill: "#ef4444" }}>POS 1</text>
      <text x="73" y="288" className="label-sm" style={{ fill: "#ef4444" }}>ROT</text>
      <text x="120" y="280" className="label-sm">POS 0</text>
      <text x="120" y="288" className="label-sm">AUS</text>
      <text x="148" y="280" className="label-sm" style={{ fill: "#22c55e" }}>POS 2</text>
      <text x="148" y="288" className="label-sm" style={{ fill: "#22c55e" }}>GRUEN</text>

      {/* Output 1 → ROT path */}
      <line x1="80" y1="256" x2="80" y2="320" className="wire" stroke={rotPath} />
      {/* Output 2 → GRUEN path - branches right */}
      <line x1="80" y1="252" x2="160" y2="252" className="wire-thin" stroke={lActive} strokeDasharray="3 2" />
      <line x1="160" y1="252" x2="160" y2="320" className="wire" stroke={gruenPath} />

      {/* ═══ COLUMN 4: B1 Endschalter (Wechslerkontakt) ═══ */}
      {/* PRIORITY BOX */}
      <rect x="50" y="310" width="280" height="100" rx="4" fill="none" stroke="#f59e0b" strokeWidth="1" strokeDasharray="4 2" />
      <text x="60" y="326" className="label-warn">SICHERHEITS-PRIORITAET: TOR OFFEN = IMMER ROT</text>

      {/* B1 label */}
      <text x="56" y="355" className="label-id">B1</text>
      <text x="56" y="365" className="label-sm">LS-11S/S</text>
      <text x="56" y="373" className="label-sm">Endschalter</text>

      {/* === ROT path: through NO contact (x=80) === */}
      <circle cx="80" cy="340" r="2.5" fill={rotPath} />
      {/* NO contact symbol - open contact that closes when actuated */}
      <circle cx="80" cy="350" r="2" stroke={rotPath} strokeWidth="1.5" fill="none" />
      <line x1="80" y1="352" x2="90" y2="370" className="wire" stroke={rotPath} />
      <circle cx="80" cy="380" r="2" stroke={rotPath} strokeWidth="1.5" fill="none" />
      <line x1="80" y1="382" x2="80" y2="400" className="wire" stroke={rotPath} />
      {/* NO label */}
      <text x="94" y="356" className="label-sm" style={{ fill: "#ef4444" }}>NO</text>
      <text x="94" y="364" className="label-sm" style={{ fill: "#ef4444" }}>13-14</text>
      <text x="94" y="380" className="label-sm">schliesst</text>
      <text x="94" y="388" className="label-sm">bei Tor</text>
      <text x="94" y="396" className="label-sm">OFFEN</text>

      {/* === GRUEN path: through NC contact (x=160) === */}
      <circle cx="160" cy="340" r="2.5" fill={gruenPath} />
      {/* NC contact symbol - closed contact */}
      <line x1="160" y1="340" x2="160" y2="350" className="wire" stroke={gruenPath} />
      <circle cx="160" cy="350" r="2" stroke={gruenPath} strokeWidth="1.5" fill="none" />
      <line x1="160" y1="352" x2="160" y2="370" className="wire" stroke={gruenPath} />
      {/* NC cross */}
      <line x1="155" y1="355" x2="165" y2="365" stroke={gruenPath} strokeWidth="1" />
      <circle cx="160" cy="380" r="2" stroke={gruenPath} strokeWidth="1.5" fill="none" />
      <line x1="160" y1="382" x2="160" y2="400" className="wire" stroke={gruenPath} />
      {/* NC label */}
      <text x="170" y="356" className="label-sm" style={{ fill: "#22c55e" }}>NC</text>
      <text x="170" y="364" className="label-sm" style={{ fill: "#22c55e" }}>21-22</text>
      <text x="170" y="380" className="label-sm">oeffnet</text>
      <text x="170" y="388" className="label-sm">bei Tor</text>
      <text x="170" y="396" className="label-sm">OFFEN</text>

      {/* Mechanical linkage (dotted) */}
      <line x1="82" y1="365" x2="158" y2="365" stroke={dimColor} strokeWidth="0.8" strokeDasharray="2 2" />

      {/* ═══ COLUMN 5: Terminal Blocks X1, X2 ═══ */}
      {/* X1 - ROT */}
      <line x1="80" y1="400" x2="80" y2="430" className="wire" stroke={rotPath} />
      <rect x="68" y="430" width="24" height="12" rx="1" fill="none" stroke={rotPath} strokeWidth="1.5" />
      <text x="74" y="439" style={{ fill: rotPath, fontSize: 7, fontWeight: 700 }}>X1</text>
      <line x1="80" y1="442" x2="80" y2="460" className="wire" stroke={rotPath} />
      <text x="94" y="440" className="label-sm" style={{ fill: "#ef4444" }}>ROT 230V</text>

      {/* X2 - GRUEN */}
      <line x1="160" y1="400" x2="160" y2="430" className="wire" stroke={gruenPath} />
      <rect x="148" y="430" width="24" height="12" rx="1" fill="none" stroke={gruenPath} strokeWidth="1.5" />
      <text x="153" y="439" style={{ fill: gruenPath, fontSize: 7, fontWeight: 700 }}>X2</text>
      <line x1="160" y1="442" x2="160" y2="460" className="wire" stroke={gruenPath} />
      <text x="174" y="440" className="label-sm" style={{ fill: "#22c55e" }}>GRUEN 230V</text>

      {/* ═══ COLUMN 6: Lamps H1, H2 ═══ */}
      {/* H1 ROT */}
      <circle cx="80" cy="480" r="14" fill={ampelRot ? "rgba(239,68,68,0.15)" : "none"} stroke={rotPath} strokeWidth="1.5" />
      <line x1="70" y1="470" x2="90" y2="490" stroke={rotPath} strokeWidth="1" />
      <line x1="90" y1="470" x2="70" y2="490" stroke={rotPath} strokeWidth="1" />
      <text x="100" y="478" className="label-id" style={{ fill: "#ef4444" }}>H1</text>
      <text x="100" y="488" className="label-sm">WERMA</text>
      <text x="100" y="496" className="label-sm">ROT 230V</text>
      {/* to N */}
      <line x1="80" y1="494" x2="80" y2="530" className="wire" stroke="#3b82f6" />
      <circle cx="80" cy="530" r="2.5" fill="#3b82f6" />

      {/* H2 GRUEN */}
      <circle cx="160" cy="480" r="14" fill={ampelGruen ? "rgba(34,197,94,0.15)" : "none"} stroke={gruenPath} strokeWidth="1.5" />
      <line x1="150" y1="470" x2="170" y2="490" stroke={gruenPath} strokeWidth="1" />
      <line x1="170" y1="470" x2="150" y2="490" stroke={gruenPath} strokeWidth="1" />
      <text x="180" y="478" className="label-id" style={{ fill: "#22c55e" }}>H2</text>
      <text x="180" y="488" className="label-sm">WERMA</text>
      <text x="180" y="496" className="label-sm">GRUEN 230V</text>
      {/* to N */}
      <line x1="160" y1="494" x2="160" y2="530" className="wire" stroke="#3b82f6" />
      <circle cx="160" cy="530" r="2.5" fill="#3b82f6" />

      {/* ═══ LOGIC TABLE (right side) ═══ */}
      <rect x="260" y="420" width="170" height="100" rx="4" fill="rgba(255,255,255,0.02)" stroke={dimColor} strokeWidth="0.8" />
      <text x="270" y="436" className="label" style={{ fontSize: 8 }}>SCHALTLOGIK</text>
      <line x1="260" y1="442" x2="430" y2="442" stroke={dimColor} strokeWidth="0.5" />
      <text x="270" y="456" className="label-sm" style={{ fill: "#f59e0b" }}>Tor OFFEN → IMMER ROT</text>
      <text x="270" y="470" className="label-sm">Tor ZU + Pos 0 → AUS</text>
      <text x="270" y="484" className="label-sm" style={{ fill: "#ef4444" }}>Tor ZU + Pos 1 → ROT</text>
      <text x="270" y="498" className="label-sm" style={{ fill: "#22c55e" }}>Tor ZU + Pos 2 → GRUEN</text>
      <text x="270" y="516" className="label-warn">Endschalter hat Prioritaet!</text>

      {/* ═══ PARTS TABLE (right side top) ═══ */}
      <rect x="260" y="50" width="170" height="130" rx="4" fill="rgba(255,255,255,0.02)" stroke={dimColor} strokeWidth="0.8" />
      <text x="270" y="66" className="label" style={{ fontSize: 8 }}>BAUTEILLISTE</text>
      <line x1="260" y1="72" x2="430" y2="72" stroke={dimColor} strokeWidth="0.5" />
      <text x="270" y="86" className="label-id" style={{ fontSize: 7 }}>Q1</text>
      <text x="290" y="86" className="label-sm">Hauptschalter</text>
      <text x="270" y="98" className="label-id" style={{ fontSize: 7 }}>F1</text>
      <text x="290" y="98" className="label-sm">LS B16A</text>
      <text x="270" y="110" className="label-id" style={{ fontSize: 7 }}>S1</text>
      <text x="290" y="110" className="label-sm">M22-WRK3 (3-Pos)</text>
      <text x="270" y="122" className="label-id" style={{ fontSize: 7 }}>B1</text>
      <text x="290" y="122" className="label-sm">LS-11S/S Federstab</text>
      <text x="270" y="134" className="label-id" style={{ fontSize: 7 }}>H1</text>
      <text x="290" y="134" className="label-sm">WERMA ROT 230V</text>
      <text x="270" y="146" className="label-id" style={{ fontSize: 7 }}>H2</text>
      <text x="290" y="146" className="label-sm">WERMA GRUEN 230V</text>
      <text x="270" y="158" className="label-id" style={{ fontSize: 7 }}>X1/X2</text>
      <text x="305" y="158" className="label-sm">Erfassungsklemmen</text>
      <text x="270" y="170" className="label-id" style={{ fontSize: 7 }}>UV</text>
      <text x="290" y="170" className="label-sm">Unterverteilung</text>
    </svg>
  );
}
